export default "__VITE_ASSET__b4c1c418__"